import {
  Avatar,
  Box,
  Button,
  Grid,
  List,
  ListItem,
  MenuItem,
  OutlinedInput,
  Paper,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "../../styles/pages/myaccountPartner.module.scss";
import styles1 from "../../styles/components/partnerSubmissionFeeModal.module.scss";
import assest from "../../json/assest";
// import Image from "next/image";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { parseCookies } from "nookies";
// import validationText from "../../json/messages/validationText";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useMutation, useQueryClient } from "react-query";
import { ProfileUpdateMutation } from "../../api/functions/user.api";
// import { any, array } from "prop-types";
import { useAppSelector } from "../../hooks/useAppSelector";
// import { logout, setLoginData } from "../../reduxtoolkit/slices/userSlice";
import useNotiStack from "../../hooks/useNotistack";
import { phoneRegExp } from "../../config/regExp";
import { trimStartAndEnd } from "../../lib/functions/_helpers.lib";
// import { useRouter } from "next/router";
// import Link from "next/link";
import EditBlueIcon from "../../ui/Icons/EditBlueIcon";
import TabBackIcon from "../../ui/Icons/TabBackIcon";
import TabSaveIcon from "../../ui/Icons/TabSaveIcon";
import { Link, useLocation } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";
import useFetch from "../../hooks/api/useFetch";
import {
  countryData,
  getAbsoluteImageURI,
} from "../../lib/functions/utils.lib";
import NOprofileImage from "../../public/assets/images/no-image.svg";

// interface forgotProps {
//   // forgotText: 'myaccount' | 'editor' | 'copywriter' | 'for_partners';
//   forgotText: 'myaccount' | 'editor' | 'copywriter' | 'for_partners' | 'for_QC' | 'for_manager';
//   accountSubmission: boolean;
// }

// interface TabPanelProps {
//   children?: React.ReactNode;
//   index: number;
//   value: number;
// }

//=== TYPES ====
// interface MyAccInput {
//   name: string;
//   last_name: string;
//   address: string;
//   city: string;
//   zip: string;
//   state: string;
//   phone: string;
//   avatar: string;
// }

// schema

const schema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .required()
    .label("First Name")
    .max(256)
    .transform(trimStartAndEnd),

  last_name: yup
    .string()
    .trim()
    .required()
    .label("Last Name")
    .max(256)
    .transform(trimStartAndEnd),

  address: yup.string().max(32),
  city: yup.string().max(32),

  zip: yup.string().max(7),
  phone: yup
    .string()
    .required()
    .matches(phoneRegExp, "Phone number is not valid")
    .label("Phone number"),

  state: yup.string().max(32),
});
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const UserCreateTabPartner = (props) => {
  let { pathname } = useLocation();
  const cookies = parseCookies();
  const userdeatails = JSON?.parse(cookies?.userdetails || "{}");

  const { userData } = useAppSelector((s) => s.userSlice);
  const {
    data: partnerData,
    isLoading: partnerIsLoading,
    isSuccess: partnerIsSuccess,
    refetch: partnerRefetch,
  } = useFetch(
    ["partner", props?.user_id],
    `admin/user?user_id=${props?.user_id}`
  );

  const [value, setValue] = React.useState(0);
  const [age, setAge] = React.useState(
    partnerData?.data?.country ? partnerData?.data?.country : ""
  );
  const [dis, setDis] = useState(true);
  const [dis1, setDis1] = useState(true);
  const [dis2, setDis2] = useState(true);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  /* const {
    handleSubmit,
    control,
    register,

    reset,
    formState: { errors },
    formState,
  } = useForm({
    resolver: yupResolver(schema),
    values: {
      name: userData?.name,
      last_name: userData?.last_name,
      address: userData?.address,
      city: userData?.city,
      zip: userData?.zip,
      state: userData?.state,
      phone: userData?.phone,
      avatar: userData?.avatar,
    },
  }); */
  // const onSubmit = (data: MyAccInput) => console.warn(data);

  const handleChange2 = (event) => {
    setAge(event.target.value);
  };
  const handleopenD = () => {
    setDis(false);
  };
  const handleopenD1 = () => {
    setDis1(false);
  };
  const handleopenD2 = () => {
    setDis2(false);
  };
  const handlecloseD = () => {
    setDis(true);
  };
  const handlecloseD1 = () => {
    setDis1(true);
  };
  const handlecloseD2 = () => {
    setDis2(true);
  };
  const { mutateAsync: ProfileUpdateMutationAA } = useMutation({
    mutationFn: ProfileUpdateMutation,
  });
  const { toastSuccess, toastError } = useNotiStack();
  const queryClient = useQueryClient();
  7;
  const [profileImage, setProfileImage] = useState(null);
  const [profileimg, setprofileimg] = useState(partnerData?.data?.avatar);

  const removeprofileImage = async () => {
    setProfileImage(null);
    setprofileimg(null);
    const formData = new FormData();
    formData.append("remove_avatar", true);
    formData.append("user_id", props?.user_id);
    await axiosInstance
      .post("admin/updateuser", formData)
      .then((response) => {
        toastSuccess("User updated successfully");
        partnerRefetch();
        props?.refetchPartnersList();
        props?.topAcqusitiorRefetch();
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const handleProfileImage1 = (e) => {
    if (
      e.target.files[0]?.type === "image/jpeg" ||
      e.target.files[0]?.type === "image/png" ||
      e.target.files[0]?.type === "image/jpg"
    ) {
      if (e.target.files[0]?.size <= 3000000) {
        setProfileImage(e.target.files[0]);
      } else {
        toastError("Please upload image of proper size.");
      }
    } else {
      toastError("Please upload image of proper format.");
    }
  };

  const [paymentType, setPaymentType] = useState(
    partnerData?.data?.payment_type
      ? partnerData?.data?.payment_type
      : parseInt(partnerData?.data?.rate_per_video)
      ? 2
      : 1
  );

  const handlePaymentType = () => {
    if (dis1) return;
    setPaymentType((prev) => {
      if (prev) return prev === 1 ? 2 : 1;
      return partnerData?.data?.payment_type
        ? partnerData?.data?.payment_type
        : parseInt(partnerData?.data?.rate_per_video)
        ? 2
        : 1;
    });
  };

  const [formData, setFormData] = useState({
    user_id: props?.user_id,
    ...partnerData?.data,
  });

  const getFormInputValue = (name) => {
    return formData[name] ? formData[name] : "";
  };

  const handleFormData = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  const handleSubmit = async () => {
    if (!formData) return;
    const partnerForm = new FormData();
    partnerForm.append("user_id", formData?.user_id);
    if (formData?.name !== partnerData?.data?.name) {
      partnerForm.append("name", formData?.name);
    }
    if (formData?.last_name !== partnerData?.data?.last_name) {
      partnerForm.append("last_name", formData?.last_name);
    }
    if (formData?.address !== partnerData?.data?.address) {
      partnerForm.append("address", formData?.address);
    }
    if (formData?.city !== partnerData?.data?.city) {
      partnerForm.append("city", formData?.city);
    }
    if (formData?.state !== partnerData?.data?.state) {
      partnerForm.append("state", formData?.state);
    }
    if (formData?.zip_code !== partnerData?.data?.zip_code) {
      partnerForm.append("zip_code", formData?.zip_code);
    }
    if (age !== partnerData?.data?.country) {
      partnerForm.append("country", age);
    }
    if (formData?.phone !== partnerData?.data?.phone) {
      partnerForm.append("phone", formData?.phone);
    }
    if (profileImage !== null) {
      partnerForm.append("avatar", profileImage);
    }
    if (formData?.account_name !== partnerData?.data?.account_name) {
      partnerForm.append("account_name", formData?.account_name);
    }
    if (formData?.revenue_share !== partnerData?.data?.revenue_share) {
      partnerForm.append("revenue_share", formData?.revenue_share);
    }
    if (paymentType !== partnerData?.data?.data?.payment_type) {
      partnerForm.append("payment_type", paymentType);
    }
    if (formData?.rate_per_video !== partnerData?.data?.rate_per_video) {
      partnerForm.append("rate_per_video", formData?.rate_per_video);
    }
    if (formData?.flat_rate !== partnerData?.data?.flat_rate) {
      partnerForm.append("flat_rate", formData?.flat_rate);
    }
    await axiosInstance
      .post("admin/updateuser", partnerForm)
      .then((response) => {
        toastSuccess("User updated successfully");
        console.warn(response?.data);
        partnerRefetch();
        props?.refetchPartnersList();
        props?.topAcqusitiorRefetch();
        setFormData({
          user_id: props?.user_id,
          ...partnerData?.data,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };
  useEffect(() => {
    setFormData((prev) => {
      return { ...prev, ...partnerData?.data };
    });
    setAge(partnerData?.data?.country ? partnerData?.data?.country : "");
  }, [partnerData?.data]);

  console.warn(partnerData?.data?.avatar);
  console.warn(profileImage);

  return (
    <>
      <Box className={styles.commTabs}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Personal Details" {...a11yProps(0)} />
          <Tab label="Account Settings" {...a11yProps(1)} />
        </Tabs>
      </Box>

      <Paper className={`${styles.accountPaper} ${styles.accountPaperPartner}`}>
        <TabPanel value={value} index={0}>
          <Box className={styles.accountFormGroup}>
            <Stack
              direction="row"
              alignItems="center"
              flexWrap="wrap"
              className={styles.labelStack}
            >
              <Typography variant="caption">Full name</Typography>

              {dis !== false ? (
                <Button onClick={handleopenD}>
                  <EditBlueIcon />
                </Button>
              ) : (
                // <Button
                //   onClick={handleSubmit(onSubmit)}
                //   className={styles.btnUpdt}
                // >
                //   Update
                // </Button>
                <Box className={styles.editSaveBtn}>
                  <Button onClick={handlecloseD}>
                    <TabBackIcon />
                  </Button>
                  <Button
                    onClick={() => {
                      handlecloseD();
                      handleSubmit();
                    }}
                  >
                    <TabSaveIcon />
                  </Button>
                </Box>
              )}
            </Stack>
            <Box className={styles.gridWrap}>
              <Grid
                container
                rowSpacing={3}
                columnSpacing={{ xs: 1, sm: 2, md: 5.75 }}
              >
                <Grid item md={3.0815}>
                  <Box className={styles.formGroup}>
                    <label>First Name</label>
                    <OutlinedInput
                      name="name"
                      onChange={handleFormData}
                      value={getFormInputValue("name")}
                      type="text"
                      disabled={dis}
                      placeholder="First Name"
                    />
                    {/* {errors.name && (
                      <p
                        style={{
                          color: "red",
                          textAlign: "left",
                          fontSize: "15px",
                        }}
                      >
                        {errors.name.message}
                      </p>
                    )} */}
                  </Box>
                </Grid>
                <Grid item md={3.0815}>
                  <Box className={styles.formGroup}>
                    <label>last name</label>
                    <OutlinedInput
                      name="last_name"
                      onChange={handleFormData}
                      value={getFormInputValue("last_name")}
                      disabled={dis}
                      placeholder={"Last Name"}
                    />
                    {/* {errors.last_name && (
                      <p
                        style={{
                          color: "red",
                          textAlign: "left",
                          fontSize: "15px",
                        }}
                      >
                        {errors.last_name.message}
                      </p>
                    )} */}
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>

          <Box className={styles.accountFormGroup}>
            <Stack
              direction="row"
              alignItems="center"
              flexWrap="wrap"
              className={styles.labelStack}
            >
              <Typography variant="caption">Physical Address</Typography>
              {/* <Button>
                  <img
                    src={assest.Iconedit}
                    width={15}
                    height={15}
                    alt="icon"
                  />
                </Button> */}
              {dis1 !== false ? (
                <Button onClick={handleopenD1}>
                  <EditBlueIcon />
                </Button>
              ) : (
                // <Button
                //   onClick={handleSubmit(onSubmit)}
                //   className={styles.btnUpdt}
                // >
                //   Update
                // </Button>
                <Box className={styles.editSaveBtn}>
                  <Button onClick={handlecloseD1}>
                    <TabBackIcon />
                  </Button>
                  <Button
                    onClick={() => {
                      handlecloseD1();
                      handleSubmit();
                    }}
                  >
                    <TabSaveIcon />
                  </Button>
                </Box>
              )}
            </Stack>
            <Box className={styles.gridWrap}>
              <Grid
                container
                rowSpacing={3.2}
                columnSpacing={{ xs: 1, sm: 2, md: 5.75 }}
              >
                <Grid item md={3.658}>
                  <Box className={styles.formGroup}>
                    <label>Address</label>
                    <OutlinedInput
                      // {...register("address")}
                      name="address"
                      onChange={handleFormData}
                      value={getFormInputValue("address")}
                      type="text"
                      placeholder={"Address"}
                      disabled={dis1}
                    />
                  </Box>
                </Grid>
                <Grid item md={2.607}>
                  <Box className={styles.formGroup}>
                    <label>City</label>
                    <OutlinedInput
                      // {...register("city")}
                      name="city"
                      onChange={handleFormData}
                      value={getFormInputValue("city")}
                      type="text"
                      placeholder={"City"}
                      disabled={dis1}
                    />
                  </Box>
                </Grid>
                <Grid item md={2.607}>
                  <Box className={styles.formGroup}>
                    <label>State</label>
                    <OutlinedInput
                      // {...register("state")}
                      name="state"
                      onChange={handleFormData}
                      value={getFormInputValue("state")}
                      type="text"
                      placeholder={"State"}
                      disabled={dis1}
                    />
                  </Box>
                </Grid>
                <Grid item md={1.792}>
                  <Box className={styles.formGroup}>
                    <label>Zip Code</label>
                    <OutlinedInput
                      // {...register("zip")}
                      name="zip_code"
                      onChange={handleFormData}
                      value={getFormInputValue("zip_code")}
                      type="text"
                      placeholder={"Zip Code"}
                      disabled={dis1}
                    />
                  </Box>
                </Grid>
                <Grid item md={3.0815}>
                  <Box className={styles.formGroup}>
                    <label>Country</label>
                    <Select
                      disabled={dis1}
                      value={age}
                      onChange={handleChange2}
                      displayEmpty
                      renderValue={() => {
                        return (
                          <span>{age?.length ? age : "Select country"}</span>
                        );
                      }}
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      <MenuItem value="">Select country</MenuItem>
                      {countryData.map((item, index) => (
                        <MenuItem
                          key={index}
                          value={`${item?.name} (${item?.code})`}
                        >{`${item?.name} (${item?.code})`}</MenuItem>
                      ))}
                      {/* <MenuItem value={10}>United Arab Emirates</MenuItem>
                      <MenuItem value={20}>United Arab Emirates</MenuItem>
                      <MenuItem value={30}>United Arab Emirates</MenuItem> */}
                    </Select>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>

          <Box className={styles.accountFormGroup}>
            <Stack
              direction="row"
              alignItems="center"
              flexWrap="wrap"
              className={styles.labelStack}
            >
              <Typography variant="caption">Phone Number</Typography>
              {/* <Button>
                  <img
                    src={assest.Iconedit}
                    width={15}
                    height={15}
                    alt="icon"
                  />
                </Button> */}
              {dis2 !== false ? (
                <Button onClick={handleopenD2}>
                  <EditBlueIcon />
                </Button>
              ) : (
                // <Button
                //   onClick={handleSubmit(onSubmit)}
                //   className={styles.btnUpdt}
                // >
                //   Update
                // </Button>
                <Box className={styles.editSaveBtn}>
                  <Button onClick={handlecloseD2}>
                    <TabBackIcon />
                  </Button>
                  <Button
                    onClick={() => {
                      handlecloseD2();
                      handleSubmit();
                    }}
                  >
                    <TabSaveIcon />
                  </Button>
                </Box>
              )}
            </Stack>
            <Box className={styles.gridWrap}>
              <Grid
                container
                rowSpacing={3}
                columnSpacing={{ xs: 1, sm: 2, md: 5.75 }}
              >
                <Grid item md={3.0815}>
                  <Box className={styles.formGroup}>
                    <OutlinedInput
                      type="number"
                      name="phone"
                      onChange={handleFormData}
                      value={getFormInputValue("phone")}
                      placeholder={"Phone Number"}
                      disabled={dis2}
                      // {...register("phone")}
                    />
                    {/* {errors.phone && (
                      <p
                        style={{
                          color: "red",
                          textAlign: "left",
                          fontSize: "15px",
                        }}
                      >
                        {errors.phone.message}
                      </p>
                    )} */}
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </TabPanel>

        <TabPanel value={value} index={1}>
          <Box
            className={`${styles.accountSettingWrapper} ${styles.accountSettingWrapperPartner}`}
          >
            <Box
              className={`${styles.forProfilePic} ${styles.forProfilePicPartner}`}
            >
              <Stack
                direction="row"
                alignItems="center"
                flexWrap="wrap"
                className={styles.labelStack}
              >
                <Typography variant="caption">Profile Picture</Typography>
              </Stack>
              <Stack
                direction="row"
                alignItems="center"
                flexWrap="wrap"
                className={styles.profileSec}
              >
                {/* <Avatar
                  alt="Profile Image"
                  // src={URL.createObjectURL(profileImage)}

                  src={
                    profileImage
                      ? URL.createObjectURL(profileImage)
                      : getAbsoluteImageURI(partnerData?.data?.avatar)
                  }
                  sx={{ width: 97, height: 97 }}
                /> */}

                {profileImage !== null ? (
                  <>
                    {/* <img
                        src={URL.createObjectURL(profileImage)}
                        width={100}
                        height={100}
                        alt={""}
                      /> */}

                    <Avatar
                      alt="Profile Image"
                      src={URL.createObjectURL(profileImage)}
                      sx={{ width: 97, height: 97 }}
                    />
                  </>
                ) : (
                  <>
                    {profileimg === null ? (
                      <Avatar
                        alt="Viral Snare"
                        src={NOprofileImage}
                        sx={{ width: 97, height: 97 }}
                      />
                    ) : (
                      <Avatar
                        alt="Profile Image"
                        src={
                          partnerData?.data?.avatar === "users/default.png"
                            ? NOprofileImage
                            : getAbsoluteImageURI(partnerData?.data?.avatar)
                        }
                        sx={{ width: 97, height: 97 }}
                      />
                    )}
                  </>
                )}

                <List>
                  <ListItem className={styles.customUploadFile}>
                    <input
                      type="file"
                      id="upload"
                      hidden
                      onChange={handleProfileImage1}
                      accept="image/*"
                    />
                    {profileImage !== null ? (
                      <>
                        <label htmlFor="update" onClick={handleSubmit}>
                          update picture
                        </label>
                      </>
                    ) : (
                      <>
                        <label htmlFor="upload">Update picture</label>
                      </>
                    )}
                  </ListItem>
                  <ListItem>
                    <Button
                      className={styles.removeBtn}
                      onClick={removeprofileImage}
                    >
                      remove it
                    </Button>
                  </ListItem>
                </List>
              </Stack>
            </Box>

            <Box className={styles.partnerAccountsSetting}>
              <Grid container spacing={2}>
                <Grid item xs={5.9}>
                  <Box className={styles.partnerAccountLeft}>
                    {pathname == "/buyers-list" || pathname == "/myaccount" ? (
                      ""
                    ) : (
                      <Box
                        className={`${styles.accountFormGroup} ${styles.accountFormGroupPartner}`}
                      >
                        <Stack
                          direction="row"
                          alignItems="center"
                          flexWrap="wrap"
                          className={styles.labelStack}
                        >
                          <Typography variant="caption">
                            Account Name
                          </Typography>

                          {dis !== false ? (
                            <Button onClick={handleopenD}>
                              <img
                                src={assest.Iconedit}
                                width={15}
                                height={15}
                                alt="icon"
                              />
                            </Button>
                          ) : (
                            // <Button
                            //   onClick={handleSubmit(onSubmit)}
                            //   className={styles.btnUpdt}
                            // >
                            //   Update
                            // </Button>
                            <Box className={styles.editSaveBtn}>
                              <Button onClick={handlecloseD}>
                                <img
                                  src={assest.replaceIcon}
                                  width={15}
                                  height={15}
                                  alt="icon"
                                />
                              </Button>
                              <Button
                                onClick={() => {
                                  handlecloseD();
                                  handleSubmit();
                                }}
                              >
                                <img
                                  src={assest.saveIcon}
                                  width={15}
                                  height={15}
                                  alt="icon"
                                />
                              </Button>
                            </Box>
                          )}
                        </Stack>

                        <Box className={styles.formGroup}>
                          <OutlinedInput
                            // {...register("name")}
                            name="account_name"
                            onChange={handleFormData}
                            value={getFormInputValue("account_name")}
                            type="text"
                            disabled={dis}
                            placeholder="Account Name"
                          />
                          {/* {errors.name && (
                            <p
                              style={{
                                color: "red",
                                textAlign: "left",
                                fontSize: "15px",
                              }}
                            >
                              {errors.name.message}
                            </p>
                          )} */}
                        </Box>
                      </Box>
                    )}

                    <Box className={styles.forEmail}>
                      <Stack
                        direction="row"
                        alignItems="center"
                        flexWrap="wrap"
                        className={styles.labelStack}
                      >
                        <Typography variant="caption">Email Address</Typography>
                      </Stack>
                      <Box className={styles.showEmail}>
                        <Typography variant="body1">
                          Your email address is{" "}
                          <strong>{getFormInputValue("email")}</strong>
                        </Typography>
                        <Typography variant="caption">
                          <img
                            src={assest.Iconcaution}
                            width={9}
                            height={8}
                            alt="icon"
                          />
                          Email address cannot be changed.
                        </Typography>
                      </Box>
                    </Box>

                    {pathname == "/myaccount" ? (
                      ""
                    ) : (
                      <Box
                        className={`${styles.accountFormGroup} ${styles.accountFormGroupPartner}`}
                      >
                        <Box className={styles.accountSubmission}>
                          <Stack
                            direction="row"
                            alignItems="center"
                            flexWrap="wrap"
                            className={styles.labelStack}
                          >
                            <Typography variant="caption">
                              {paymentType === 2
                                ? "Fee per Submission"
                                : "Salary"}
                            </Typography>

                            {dis1 !== false ? (
                              <Button onClick={handleopenD1}>
                                <img
                                  src={assest.Iconedit}
                                  width={15}
                                  height={15}
                                  alt="icon"
                                />
                              </Button>
                            ) : (
                              // <Button
                              //   onClick={handleSubmit(onSubmit)}
                              //   className={styles.btnUpdt}
                              // >
                              //   Update
                              // </Button>
                              <Box className={styles.editSaveBtn}>
                                <Button onClick={handlecloseD1}>
                                  <img
                                    src={assest.replaceIcon}
                                    width={15}
                                    height={15}
                                    alt="icon"
                                  />
                                </Button>
                                <Button
                                  onClick={() => {
                                    handlecloseD1();
                                    handleSubmit();
                                  }}
                                >
                                  <img
                                    src={assest.saveIcon}
                                    width={15}
                                    height={15}
                                    alt="icon"
                                  />
                                </Button>
                              </Box>
                            )}
                          </Stack>

                          <Button
                            className={styles.accountSubmissionBtn}
                            onClick={handlePaymentType}
                          >
                            {paymentType === 2
                              ? "Change to Salary"
                              : "Change to Fee per Submission"}
                          </Button>
                        </Box>
                        <Box className={styles.formGroup}>
                          <Box className={styles.partnerFromGroupSub}>
                            <OutlinedInput
                              // {...register("name")}
                              name={
                                paymentType === 2
                                  ? "flat_rate"
                                  : "rate_per_video"
                              }
                              onChange={handleFormData}
                              value={getFormInputValue(
                                paymentType === 2
                                  ? "flat_rate"
                                  : "rate_per_video"
                              )}
                              type="text"
                              disabled={dis1}
                              placeholder={
                                paymentType === 2
                                  ? "Fee per Submission"
                                  : "Salary"
                              }
                            />
                          </Box>
                          {/* {errors.name && (
                            <p
                              style={{
                                color: "red",
                                textAlign: "left",
                                fontSize: "15px",
                              }}
                            >
                              {errors.name.message}
                            </p>
                          )} */}
                        </Box>
                      </Box>
                    )}

                    <Stack
                      direction="row"
                      alignItems="center"
                      flexWrap="wrap"
                      className={styles.forgotPassword}
                    >
                      <Typography variant="h3">
                        {props?.forgotText === "myaccount"
                          ? "Forgot Your Password?"
                          : props?.forgotText === "editor"
                          ? "Editor Forgot his Password?"
                          : props?.forgotText === "copywriter"
                          ? "Copywriter Forgot his Password?"
                          : props?.forgotText === "for_partners"
                          ? "Partner Forgot his Password?"
                          : props?.forgotText === "for_QC"
                          ? "QC Agent Forgot his Password?"
                          : props?.forgotText === "for_manager"
                          ? "Manager Forgot his Password?"
                          : null}
                        {/* {pathname=== "/editors"
                    ? "Editor Forgot his Password?"
                    : pathname=== "/copywriters"
                      ? "Copywriter Forgot his Password?"
                      : "Forgot Your Password?"} */}
                      </Typography>
                      <Link to="/password-recovery" className={styles.linedBtn}>
                        {" "}
                        Reset Password
                      </Link>
                      {/* <Button className={styles.linedBtn}>Reset Password</Button> */}
                    </Stack>
                  </Box>
                </Grid>
                {props.accountSubmission && (
                  <Grid item xs={6.1}>
                    <Box className={styles.partnerAccountRight}>
                      <Box className={styles.forEmail}>
                        <Stack
                          direction="row"
                          alignItems="center"
                          flexWrap="wrap"
                          className={styles.labelStack}
                        >
                          <Typography variant="caption">
                            Submission Page
                          </Typography>
                        </Stack>
                        <Box className={styles.showEmail}>
                          <Typography variant="body1">
                            Your submission page URL is{" "}
                            <strong>
                              {getFormInputValue("submission_link")}
                            </strong>
                          </Typography>
                          <Typography variant="caption">
                            <img
                              src={assest.Iconcaution}
                              width={9}
                              height={8}
                              alt="icon"
                            />
                            Submission page cannot be changed.
                          </Typography>
                        </Box>
                      </Box>

                      {pathname == "/buyers-list" ? (
                        ""
                      ) : (
                        <Box className={styles.accountFormGroup}>
                          <Box className={styles.accountSubmission}>
                            <Stack
                              direction="row"
                              alignItems="center"
                              flexWrap="wrap"
                              className={styles.labelStack}
                            >
                              <Typography variant="caption">
                                Revenue Share
                              </Typography>

                              {dis2 !== false ? (
                                <Button onClick={handleopenD2}>
                                  <img
                                    src={assest.Iconedit}
                                    width={15}
                                    height={15}
                                    alt="icon"
                                  />
                                </Button>
                              ) : (
                                // <Button
                                //   onClick={handleSubmit(onSubmit)}
                                //   className={styles.btnUpdt}
                                // >
                                //   Update
                                // </Button>
                                <Box className={styles.editSaveBtn}>
                                  <Button onClick={handlecloseD2}>
                                    <img
                                      src={assest.replaceIcon}
                                      width={15}
                                      height={15}
                                      alt="icon"
                                    />
                                  </Button>
                                  <Button
                                    onClick={() => {
                                      handlecloseD2();
                                      handleSubmit();
                                    }}
                                  >
                                    <img
                                      src={assest.saveIcon}
                                      width={15}
                                      height={15}
                                      alt="icon"
                                    />
                                  </Button>
                                </Box>
                              )}
                            </Stack>
                          </Box>

                          <Box className={styles.formGroup}>
                            <Box className={styles.partnerFromGroup}>
                              <OutlinedInput
                                // {...register("name")}
                                name="revenue_share"
                                onChange={handleFormData}
                                value={getFormInputValue("revenue_share")}
                                type="text"
                                disabled={dis2}
                                placeholder="Revenue Share"
                              />
                            </Box>
                            {/* {errors.name && (
                              <p
                                style={{
                                  color: "red",
                                  textAlign: "left",
                                  fontSize: "15px",
                                }}
                              >
                                {errors.name.message}
                              </p>
                            )} */}
                          </Box>
                        </Box>
                      )}
                    </Box>
                  </Grid>
                )}
                {pathname == "/myaccount" ? (
                  ""
                ) : (
                  <Box className={styles.lastActive}>
                    <p>Last Active: April 12, 2023 at 5:25:33 PM UTC</p>
                  </Box>
                )}
              </Grid>
            </Box>
          </Box>
        </TabPanel>
      </Paper>
    </>
  );
};

export default UserCreateTabPartner;
